import { ArchCard } from './primitives/ArchCard';
import { MonoKicker } from './primitives/MonoKicker';

const verbs = [
    {
        n: '1',
        title: 'Learn',
        body: 'We spend time in your practice before we build anything. What you document, what you chase, which evenings get eaten and by what.',
    },
    {
        n: '2',
        title: 'Build',
        body: 'Templates, filing rules, integrations — configured by us and handed over working. Nothing arrives as a setup guide for you to get to later.',
    },
    {
        n: '3',
        title: 'Extend',
        body: 'Every quarter we come back with the next thing worth automating. The scope grows with the practice, and so does what you get back.',
    },
];

export function EngagementVerbs() {
    return (
        <div
            id="how"
            className="w-full scroll-mt-[72px] border-b border-border bg-card"
        >
            <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-12 px-[clamp(20px,5vw,72px)] py-[clamp(56px,9vw,88px)]">
                <div className="flex max-w-2xl flex-col gap-4">
                    <MonoKicker data-reveal>How we work</MonoKicker>
                    <h2
                        data-reveal
                        className="font-display text-[clamp(30px,4vw,40px)] leading-[1.15]"
                    >
                        Three verbs. That&rsquo;s the engagement.
                    </h2>
                </div>

                <div className="grid grid-cols-[repeat(auto-fit,minmax(min(280px,100%),1fr))] gap-6">
                    {verbs.map((verb) => (
                        <ArchCard
                            key={verb.title}
                            data-reveal
                            tone="cream"
                            className="flex flex-col gap-6 p-[clamp(28px,4vw,48px)] pt-[clamp(48px,7vw,72px)]"
                        >
                            <h3 className="flex items-baseline gap-2 font-display text-[26px] leading-[1.2] text-primary">
                                <span className="font-mono text-[18px]">
                                    {verb.n}·
                                </span>
                                {verb.title}
                            </h3>
                            <p className="text-[16px] leading-[1.55] text-muted-foreground">
                                {verb.body}
                            </p>
                        </ArchCard>
                    ))}
                </div>
            </div>
        </div>
    );
}
